import { render, staticRenderFns } from "./editOrgaManager.vue?vue&type=template&id=0dcb4b76&scoped=true"
import script from "./editOrgaManager.vue?vue&type=script&lang=js"
export * from "./editOrgaManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcb4b76",
  null
  
)

export default component.exports